import { z } from 'zod'

//@ts-ignore
export const ForgotPasswordSchema = z.object({
  email: z
    .string({ required_error: 'Por favor, ingresa un email válido.' })
    .email('Por favor, ingresa un email válido.'),
})

export interface IForgotPasswordSchema
  extends z.infer<typeof ForgotPasswordSchema> {}
